import { QueryClient } from '@tanstack/react-query';

/**
 * React Query Client Configuration
 *
 * Centralized configuration for React Query.
 * This can be imported and used in tests or other parts of the application.
 */
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // Don't refetch on window focus to avoid unnecessary API calls
            refetchOnWindowFocus: false,

            // Retry failed requests once before showing error
            retry: 1,

            // Data stays fresh for 5 minutes before being considered stale
            staleTime: 5 * 60 * 1000, // 5 minutes

            // Garbage collection time - cache data for 10 minutes
            gcTime: 10 * 60 * 1000, // 10 minutes
        },
        mutations: {
            // Retry failed mutations once
            retry: 1,
        },
    },
});

/**
 * Clear all cached queries
 * Useful for logout or when user data needs to be refreshed
 */
export const clearQueryCache = () => {
    queryClient.clear();
};

/**
 * Invalidate specific queries by key
 * Forces refetch of the specified queries
 */
export const invalidateQueries = (queryKey: string[]) => {
    queryClient.invalidateQueries({ queryKey });
};

